import { render, staticRenderFns } from "./Type14c.vue?vue&type=template&id=229a23d2&"
import script from "./Type14c.vue?vue&type=script&lang=js&"
export * from "./Type14c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports